var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cascade",class:{show: _vm.showCascade}},_vm._l((_vm.svgFill),function(ref,idx){
var fill = ref.fill;
var stroke = ref.stroke;
return _c('Outline',{key:idx,attrs:{"idx":idx,"length":_vm.svgFill.length - 1,"fill":fill,"stroke":("rgb(" + stroke + ", " + (0.25) + ")")}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }